exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".projectLink a .bar{-webkit-transition:background .5s;transition:background .5s}@media screen and (max-width:1600px){.projectLink a br{display:block!important}.projectLink a .bar{display:none}}.projectLink a .media{width:45vw;max-width:780px;position:fixed;opacity:0;top:0;left:0;display:block;pointer-events:none;-webkit-transition:opacity .3s;transition:opacity .3s;z-index:-1}.projectLink a .media.isHover{opacity:1;-webkit-transition:opacity .2s;transition:opacity .2s}.projectLink a .media img,.projectLink a .media video{width:100%}", ""]);

// exports
